import "core-js/modules/es.array.push.js";
import webUni from '@/../public/js/uni.webview.1.5.4';
// 上次导航时间
let lastNaviTime = 0;
// 上次导航发送状态
let lastNaviState = 0;

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();
  const diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {number} time
 * @returns {string}
 */
export function formatTimeSecond(time = 0) {
  if (time < 60) return `${time}秒`;
  let m = Number.parseInt(time / 60);
  let s = time % 60;
  if (s == 0) return `${m}分钟`;
  return `${m}分钟${s}秒`;
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * 获取方向
 * @param {Object} coord1
 * @param {Object} coord2
 * @returns {Number}
 */
export function getBearing(coord1, coord2) {
  const lat1 = coord1.latitude * Math.PI / 180;
  const lon1 = coord1.longitude * Math.PI / 180;
  const lat2 = coord2.latitude * Math.PI / 180;
  const lon2 = coord2.longitude * Math.PI / 180;
  const delta_lon = lon2 - lon1;
  const bearing = Math.atan2(Math.sin(delta_lon) * Math.cos(lat2), Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(delta_lon));
  return bearing * 180 / Math.PI;
}

/**
 * 节流函数
 * @param {Function} fn callback
 * @param {Number} delay 延时
 * @returns {Function}
 */
export function throttleFn(fn, delay) {
  let lastTime = 0;
  return () => {
    const now = Date.now();
    if (now - lastTime >= delay) {
      fn.apply(this, arguments);
      lastTime = now;
    }
  };
}

/**
 * 防抖函数
 * @param {Function} fn callback
 * @param {Number} delay 延时
 * @returns {Function}
 */
export function debounce(fn, delay) {
  let timer = null;
  return () => {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * 通知uniapp
 * @param {Object} data
 */
export function noticeUniappHandler(data) {
  var _window, _window$android;
  webUni.webView.postMessage({
    data
  });
  (_window = window) === null || _window === void 0 ? void 0 : (_window$android = _window.android) === null || _window$android === void 0 ? void 0 : _window$android.message(JSON.stringify(data));
  // console.log('noticeUniappHandler', JSON.stringify(data))
}

/**
 * 通知uniapp存储数据
 * @param {string} storageKey
 * @param {Object} data
 */
export function noticeUniappStore(storageKey, data) {
  noticeUniappHandler({
    type: 'storage',
    storageKey,
    jsonData: JSON.stringify(data)
  });
}

/**
 * 通知uniapp记录日志
 * @param {string} log
 */
export function noticeUniappRecordLog(log) {
  noticeUniappHandler({
    type: 'recordLog',
    msg: log
  });
}

/**
 * 通知uniapp 导航记录
 * @param {number} naviState 导航状态，1-开始；2-结束
 */
export function noticeUniappAddNavi(naviState) {
  var _routePath$transits$;
  if (new Date().getTime() - lastNaviTime < 5000 && lastNaviState === naviState) return console.log('noticeUniappAddNavi-return', new Date().getTime() - lastNaviTime, naviState);
  // naviState 导航状态，1-开始；2-结束
  let routePath = JSON.parse(localStorage.getItem('routePath'));
  let segments = (routePath === null || routePath === void 0 ? void 0 : (_routePath$transits$ = routePath.transits[0]) === null || _routePath$transits$ === void 0 ? void 0 : _routePath$transits$.segments) || [];
  // driveMode 导航模式，1-驾车；2-步行
  let driveMode = localStorage.getItem('driveMode') - 0 || 1;
  let startPoint = JSON.parse(localStorage.getItem('startPoint'));
  let endPoint = JSON.parse(localStorage.getItem('endPoint'));
  let mapOptions = JSON.parse(localStorage.getItem('mapOptions'));
  let params = {
    device_id: '',
    mode: driveMode,
    action: naviState,
    start_point: {
      map_id: startPoint.bdid || mapOptions.bdid,
      building_id: startPoint.bdid || '',
      floor_id: startPoint.floorId || '',
      poi_id: startPoint.poiId || '',
      poi_name: startPoint.text || '',
      address: startPoint.address || '',
      lon_lat: `${startPoint.lon},${startPoint.lat}`,
      detail: JSON.stringify(startPoint)
    },
    end_point: {
      map_id: endPoint.bdid || mapOptions.bdid,
      building_id: endPoint.bdid || '',
      floor_id: endPoint.floorId || '',
      poi_id: endPoint.poiId || '',
      poi_name: endPoint.text || '',
      address: endPoint.address || '',
      lon_lat: `${endPoint.lon},${endPoint.lat}`,
      detail: JSON.stringify(endPoint)
    },
    path: JSON.stringify(segments),
    created_at: parseTime(new Date().getTime())
  };
  console.log('noticeUniappAddNavi-params', params);
  lastNaviTime = new Date().getTime();
  lastNaviState = naviState;
  noticeUniappHandler({
    type: 'ajax',
    msg: 'addNavi',
    jsonData: JSON.stringify({
      navigations: [params]
    })
  });
}
/**
 * 计算经纬度往北偏移 n 米后的经纬度
 * @param {LonLat} center 是中心点的经纬度[lon, lat]
 * @param {Number} distanceMeters 是移动的距离，单位是米
 * @param {Number} bearingDegrees 是移动的方向角度，顺时针方向，北为0度
 */
// export function calculateMovePoint(center, distanceMeters, bearingDegrees) {
//   let lon = Number(center[0])
//   let lat = Number(center[1])
//   // let lon = center[0]
//   // let lat = center[1]
//   // 将距离从米转换为度
//   let degreesPerMeter = 1 / 111320
//   let distanceDegrees = distanceMeters * degreesPerMeter
//   // 将方向角度转换为弧度
//   let bearingRadians = (bearingDegrees * Math.PI) / 180
//   // 计算纬度增量
//   let latChange = distanceDegrees * Math.cos(bearingRadians)
//   // 计算新的纬度
//   let newLat = lat + latChange
//   // 计算经度增量
//   let lonChange = distanceDegrees * Math.sin(bearingRadians)
//   // 计算新的经度
//   let newLon = lon + Number(lonChange)
//   // 返回新的经纬度坐标
//   return [newLon, newLat]
// }

export function calculateMovePoint(center, distanceMeters, bearingDegrees) {
  let lon = Number(center[0]);
  let lat = Number(center[1]);
  // 地球半径，单位为米
  const R = 6371e3;
  // 将角度转换为弧度
  const φ1 = lat * Math.PI / 180; // 纬度
  const λ1 = lon * Math.PI / 180; // 经度
  const θ = bearingDegrees * Math.PI / 180; // 偏移方向
  const Δ = distanceMeters / R; // 将距离转换为弧度

  // 计算新的纬度
  const φ2 = Math.asin(Math.sin(φ1) * Math.cos(Δ) + Math.cos(φ1) * Math.sin(Δ) * Math.cos(θ));
  // 计算新的经度
  const λ2 = λ1 + Math.atan2(Math.sin(θ) * Math.sin(Δ) * Math.cos(φ1), Math.cos(Δ) - Math.sin(φ1) * Math.sin(φ2));

  // 将弧度转换回角度
  const newLat = φ2 * (180 / Math.PI);
  const newLng = λ2 * (180 / Math.PI);

  // return { lat: newLat, lng: newLng }
  return [newLng, newLat];
}

/**
 * 计算连个经纬度之间的距离
 * @param {Number} lat1
 * @param {Number} lon1
 * @param {Number} lat2
 * @param {Number} lon2
 * @returns
 */
export function calculateDistance(lon1, lat1, lon2, lat2) {
  const earthRadius = 6371000; // 地球半径（单位：米）

  // 将经纬度转换为弧度
  const lat1Rad = toRadians(lat1);
  const lon1Rad = toRadians(lon1);
  const lat2Rad = toRadians(lat2);
  const lon2Rad = toRadians(lon2);

  // 计算经纬度的差值
  const deltaLat = lat2Rad - lat1Rad;
  const deltaLon = lon2Rad - lon1Rad;

  // 应用 Haversine 公式计算距离
  const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = earthRadius * c;
  return Number.parseInt(distance);
}
function toRadians(degrees) {
  return degrees * (Math.PI / 180);
}

/**
 * 判断当前点是否在多边形内
 * @param {Array} point 经纬度点
 * @param {Array} polygon 经纬度多边形点集
 * @returns Boolean
 */
export function isPointInPolygon(point, polygon) {
  let x = point[0],
    y = point[1];
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    let xi = polygon[i][0],
      yi = polygon[i][1];
    let xj = polygon[j][0],
      yj = polygon[j][1];
    let intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

/**
 * 通过连续的3个经纬度点计算出左转还是右转
 * @param {Number} lonA
 * @param {Number} latA
 * @param {Number} lonB
 * @param {Number} latB
 * @param {Number} lonC
 * @param {Number} latC
 * @returns
 */
export function calculateTurnDirection(lonA, latA, lonB, latB, lonC, latC) {
  // 将经纬度转换为弧度
  let radLonA = lonA * (Math.PI / 180);
  let radLatA = latA * (Math.PI / 180);
  let radLonB = lonB * (Math.PI / 180);
  let radLatB = latB * (Math.PI / 180);
  let radLonC = lonC * (Math.PI / 180);
  let radLatC = latC * (Math.PI / 180);

  // 计算向量 AB 和向量 BC 的坐标差值
  let deltaX_AB = radLonB - radLonA;
  let deltaY_AB = radLatB - radLatA;
  let deltaX_BC = radLonC - radLonB;
  let deltaY_BC = radLatC - radLatB;

  // 计算向量 AB 和向量 BC 的叉乘结果
  let crossProduct = deltaX_AB * deltaY_BC - deltaY_AB * deltaX_BC;

  // 计算夹角的弧度
  let angleRad = Math.atan2(crossProduct, deltaX_AB * deltaX_BC + deltaY_AB * deltaY_BC);

  // 将弧度转换为度数
  let angleDeg = angleRad * (180 / Math.PI);

  // 调整角度范围为 [0, 180)
  angleDeg = angleDeg > 0 ? 180 - angleDeg % 180 : 180 + angleDeg % 180;

  // 判断左转还是右转
  let direction = crossProduct > 0 ? '左转' : '右转';
  return {
    direction: direction,
    angle: angleDeg
  };
}

/**
 * 计算当前位置在导航路线上的投影点和方向
 * @param {Object} routeData - 路线数据 {steps: [{floorId, polyline}]}
 * @param {Object} currentPos - 当前位置 {lon, lat, ...}
 * @returns {{projection: [number, number], direction: number}} 投影点坐标和方向(角度)
 */
export function calculateRouteProjection(routeData, currentPos) {
  // 提取所有路线点
  const allPoints = [];
  routeData.steps.forEach(step => {
    allPoints.push(...step.polyline);
  });
  let minDistance = Infinity;
  let projection = null;
  let segmentIndex = -1;

  // 1. 找到距离当前位置最近的路线段
  for (let i = 0; i < allPoints.length - 1; i++) {
    const start = allPoints[i];
    const end = allPoints[i + 1];

    // 计算点到线段的距离和投影点
    const [dist, proj] = pointToSegmentDistance([currentPos.lon, currentPos.lat], start, end);
    if (dist < minDistance) {
      minDistance = dist;
      projection = proj;
      segmentIndex = i;
    }
  }

  // 2. 计算路线方向(从当前线段起点到终点的方向)
  const directionSegment = allPoints.slice(segmentIndex, segmentIndex + 2);
  const direction = calculateBearing(directionSegment[0], directionSegment[1]);
  return {
    projection: projection,
    direction: direction
  };
}

// 计算点到线段的距离和投影点
export function pointToSegmentDistance(point, segmentStart, segmentEnd) {
  const x = point[0],
    y = point[1];
  const x1 = segmentStart[0],
    y1 = segmentStart[1];
  const x2 = segmentEnd[0],
    y2 = segmentEnd[1];

  // 计算线段长度平方
  const l2 = (x2 - x1) ** 2 + (y2 - y1) ** 2;
  if (l2 === 0) return [distance(point, segmentStart), segmentStart];

  // 计算投影比例
  let t = ((x - x1) * (x2 - x1) + (y - y1) * (y2 - y1)) / l2;
  t = Math.max(0, Math.min(1, t));

  // 计算投影点
  const projection = [x1 + t * (x2 - x1), y1 + t * (y2 - y1)];

  // 返回距离和投影点
  return [distance(point, projection), projection];
}

// 计算两点之间的距离
export function distance(p1, p2) {
  const dx = p1[0] - p2[0];
  const dy = p1[1] - p2[1];
  return Math.sqrt(dx * dx + dy * dy);
}

// 计算两点之间的方位角(从正北方向顺时针角度)
export function calculateBearing(start, end) {
  const lon1 = start[0] * Math.PI / 180;
  const lat1 = start[1] * Math.PI / 180;
  const lon2 = end[0] * Math.PI / 180;
  const lat2 = end[1] * Math.PI / 180;
  const y = Math.sin(lon2 - lon1) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
  let bearing = Math.atan2(y, x) * 180 / Math.PI;
  bearing = (bearing + 360) % 360;
  return bearing;
}